if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");
        this.form.querySelector("[name=id]").disabled = false;
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.cart =
          document.querySelector("cart-notification") || document.querySelector("cart-drawer");
        this.submitButton = this.querySelector('[type="submit"]');
        this.buyNowButton = this.querySelector("[data-buy-now-js]");
        if (document.querySelector("cart-drawer"))
          this.submitButton.setAttribute("aria-haspopup", "dialog");

        this.hideErrors = this.dataset.hideErrors === "true";

        if (this.buyNowButton) {
          this.buyNowButton.addEventListener("click", evt => {
            evt.preventDefault();

            if (this.buyNowButton.getAttribute("aria-disabled") === "true") return;

            this.handleErrorMessage();

            this.buyNowButton.setAttribute("aria-disabled", true);
            this.buyNowButton.classList.add("loading");
            this.querySelector(".loading-overlay__spinner").classList.remove("hidden");

            const formData = new FormData(this.form);

            fetch("/cart/clear.js", { method: "POST" })
              .then(() => {
                const upsellId = formData.get("upsellId");
                const addUpsell = upsellId
                  ? fetch("/cart/add.js", {
                      method: "POST",
                      headers: { "Content-Type": "application/json" },
                      body: JSON.stringify({
                        items: [
                          {
                            id: upsellId,
                            quantity: 1,
                          },
                        ],
                      }),
                    }).then(res => res.json())
                  : Promise.resolve();

                return addUpsell;
              })
              .then(() => {
                return fetch("/cart/add.js", {
                  method: "POST",
                  headers: { "Content-Type": "application/json" },
                  body: JSON.stringify({
                    items: [
                      {
                        id: formData.get("id"),
                        quantity: formData.get("quantity") || 1,
                      },
                    ],
                  }),
                }).then(res => res.json());
              })
              .then(data => {
                console.log("Items added:", data);
                window.location = "/checkout";
              })
              .catch(err => {
                console.error("Error adding items:", err);
                this.handleErrorMessage("Failed to add product.");
              })
              .finally(() => {
                this.buyNowButton.classList.remove("loading");
                this.querySelector(".loading-overlay__spinner").classList.add("hidden");
              });
          });
        }
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute("aria-disabled") === "true") return;

        this.handleErrorMessage();

        this.submitButton.setAttribute("aria-disabled", true);
        this.submitButton.classList.add("loading");
        this.querySelector(".loading-overlay__spinner").classList.remove("hidden");

        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            "sections",
            this.cart.getSectionsToRender().map(section => section.id)
          );
          formData.append("sections_url", window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        // Define the second fetch call as a function
        const mainFetch = () => {
          fetch(`${routes.cart_add_url}`, config)
            .then(response => response.json())
            .then(response => {
              if (response.status) {
                publish(PUB_SUB_EVENTS.cartError, {
                  source: "product-form",
                  productVariantId: formData.get("id"),
                  errors: response.description,
                  message: response.message,
                });
                this.handleErrorMessage(response.description);

                const soldOutMessage = this.submitButton.querySelector(".sold-out-message");
                if (!soldOutMessage) return;
                this.submitButton.setAttribute("aria-disabled", true);
                this.submitButton.querySelector("span").classList.add("hidden");
                soldOutMessage.classList.remove("hidden");
                this.error = true;
                return;
              } else if (!this.cart) {
                window.location = window.routes.cart_url;
                return;
              }

              if (!this.error)
                publish(PUB_SUB_EVENTS.cartUpdate, {
                  source: "product-form",
                  productVariantId: formData.get("id"),
                });
              this.error = false;
              const quickAddModal = this.closest("quick-add-modal");
              if (quickAddModal) {
                document.body.addEventListener(
                  "modalClosed",
                  () => {
                    this.cart.renderContents(response);
                  },
                  { once: true }
                );
                quickAddModal.hide(true);
              } else {
                this.cart.renderContents(response);
              }
            })
            .catch(e => {
              console.error(e);
            })
            .finally(() => {
              this.submitButton.classList.remove("loading");
              if (this.cart && this.cart.classList.contains("is-empty"))
                this.cart.classList.remove("is-empty");
              if (!this.error) this.submitButton.removeAttribute("aria-disabled");
              this.querySelector(".loading-overlay__spinner").classList.add("hidden");
            });
        };

        const bonusProducts = document.querySelectorAll("[data-additional-product]");
        const bonusItems = [];

        bonusProducts.forEach(el => {
          if (el.checked) {
            const addVariantID = el.dataset.additionalProductId;
            bonusItems.push({
              id: addVariantID,
              quantity: 1,
            });
          }
        });

        const upsellId = formData.get("upsellId");
        if (upsellId) {
          bonusItems.push({
            id: upsellId,
            quantity: 1,
          });
        }

        fetch("/cart/add.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "X-Requested-With": "XMLHttpRequest",
          },
          body: JSON.stringify({
            items: bonusItems,
          }),
        })
          .then(response => response.json())
          .then(data => {
            console.log("Items Added to Cart", data);
            mainFetch();
          })
          .catch(error => {
            console.error("Error adding items to cart:", error);
            mainFetch(); // всё равно открываем drawer
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector(".product-form__error-message-wrapper");
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(".product-form__error-message");

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}


document.addEventListener("DOMContentLoaded", event => {
  let modal = document.getElementById("checkoutModal");
  let checkoutbtn = document.getElementById("modalOpen");

  checkoutbtn.onclick = function () {
    console.log("Button clicked.");
    modal.style.display = "block";
    initializeTimer();
  };

  function isOnClickAdded(element) {
    return typeof element.onclick === "function";
  }

  if (isOnClickAdded(checkoutbtn)) {
    console.log("Onclick has been added to the button.");
  } else {
    console.log("Onclick has not been added to the button.");
  }
});

